import React, { useEffect, useState } from 'react';
import { Button, Dialog, Radio, Checkbox, Balloon, Tag } from '@alifd/next';
import styles from './index.module.scss';
import { Servlets } from '@/service';

export default (props) => {
  const { type } = props // type 判断哪个页面使用
  const [dialogShow, setDialog] = useState(false);// 指定地区Dialog是否显示
  const [provinceSelectConfirm, setProvinceSelectConfirm] = useState([]);// 点击确定才会改变的 checkBox选中的省份id
  const [selectAllProvince, setSelectAllProvince] = useState([]);// 全选
  const [citySelectConfirm, setCitySelectConfirm] = useState([])// 点击确定才会改变的 checkBox选中的城市id
  const [area, setArea] = useState({"type": 1,"ids": []});// 催付地区
  const [disabled, setDisabled] = useState(false);// 禁用
  const [areaType, setAreaType] = useState(1)// 指定地区/排除地区
  const [tagList, setTagList] = useState([]);// 渲染标签
  const { Group: TagGroup } = Tag;// 正常标签
  const { Closeable: CloseableTag } = Tag;// 关闭标签
  const [allData, setAllData] = useState([]); // 省市接口返回的数据
  const [provinces, setProvinces] = useState([]); // 全选的省
  const [provincesCopy, setProvincesCopy] = useState([]); // 全选的省副本
  const [provincesIndeterminate] = useState(new Map()); // 省的中间选中状态
  const [provincesIndeterminateCopy] = useState(new Map()); // 省的中间选中状态副本
  const [provinceToCityMap, setCities] = useState(new Map()); // 每个省下城市的选中状态
  const [provinceToCityMapCopy, setCitiesCopy] = useState(new Map()); // 每个省下城市的选中状态副本
  const [allConnectArr ] = useState(new Map()); // 全部省市map
  const [resultArr, setResultArr] = useState([]); // 和城市能否选中挂钩
  const [direction, setDirection] = useState(0); //  实时计算当前省市距页面顶部距离，便于判断向上还是向下弹
  const [opDescValueProvince, setOpDescValueProvince] = useState([]); // 传值，全选省+部分选择了城市的省+直辖市
  const [citySelect, setCitySelect] = useState([]);// 选中城市
  const [allCitys, setAllCitys] = useState([]); //接口返回的全部城市信息数组
  const [provinceSelect, setProvinceSelect] = useState([]);

  useEffect(() => {
    getProvinceList();
    getCity();
    cityFormat();
  }, []);

  // 初始化省信息
  const getProvinceList = () => {
    return Servlets('getProvinces', {}).then((res) => {
      let tempList = [];
      res.data.forEach((item, index) => {
        tempList.push(item?.provinceId);
      })
      setSelectAllProvince(...selectAllProvince, tempList);
    }).catch(e => {
      console.log(e)
    });
  }

  // 初始化城市信息
  const getCity = () => {
    return Servlets('getCity', {}).then((res) => {
      // productData(res.data);
      setAllCitys(res.data);
    }).catch(e => {
      console.log(e)
    })
  }

  // 格式化数据
  const cityFormat = () => {
    return Servlets('getCity', {}).then((res) => {
      productData(res.data);
    }).catch(e => {
      console.log(e)
    })
  }

  // 处理数据格式，递归将接口返回的数据处理成34个省市的map
  const productData = (data) => {
    const groupData = [];
    const getAllData = function(data){ //进入该方法则递归入参
        const emptyArr = [];
        data.forEach((item, index) => {
          const firstId = data[0]?.provinceId;
          if(item?.provinceId === firstId){
            emptyArr.push(item);
          }
        })
        data.splice(0,emptyArr.length);
        groupData.push(emptyArr);
      if(data.length > 0){ //还存在数据，继续递归处理剩余数据
        getAllData(data)
      }else{ //数据已全部处理完成，获得了一个省市数组，继续处理该数组中每个成员，得到最终格式
        const finalArr = [];
        groupData.forEach((item, index) => {
          const emptyObj = {};
          emptyObj.areaName = item[0].provinceName;
          emptyObj.code = item[0]?.provinceId;
          emptyObj.subAreas = [];
          item.forEach((city, cityIndex) => {
            const emptyCityObj = {};
            emptyCityObj.area_name = city.cityName;
            emptyCityObj.code = city.cityId;
            emptyObj.subAreas.push(emptyCityObj);
          })
          finalArr.push(emptyObj);
        })
        setAllData(finalArr);
        for(let i of finalArr){
          const arr = [];
          for(let item of i.subAreas){
            arr.push(item.code);
          }
          allConnectArr.set(i.code,arr);
        }
      }
    }
    getAllData(data);
  }
  /**
   * 省勾选方法
   */
   const onCheckProvince = (provinceIds) => {
    //设置选中的所有省
    setProvinces(provinceIds);
    //选中选中省下的所有城市，取消未选中省下的所有城市
    allConnectArr.forEach((value,key)=>{
        let find=provinceIds.includes(key);
        let selelctCities=provinceToCityMap.get(key);
        if(find){
          setCities(provinceToCityMap.set(key,value));
          provincesIndeterminate.set(key,false);
        }else{
          if(selelctCities===undefined || selelctCities.length===0||value.length===selelctCities.length){
            setCities(provinceToCityMap.set(key,[]));
            provincesIndeterminate.set(key,false);
          }else{
            setCities(provinceToCityMap.set(key,selelctCities));
            provincesIndeterminate.set(key,true);
          }
        }
    });
    setData();
  };

  /**
   * 城市勾选方法
   */
  const onChangeCity = (provinceId, citys) => {
    let resultObj = {};
    resultObj.key = provinceId;
    resultObj.value = citys;
    setResultArr([...resultArr,resultObj]);
    setCities(provinceToCityMap.set(provinceId,citys));
    let totalCities=allConnectArr.get(provinceId);
    provincesIndeterminate.set(provinceId,!!citys.length && citys.length!==totalCities.length);
    if(citys.length===totalCities.length){
      //这里表示省下的所有城市被选中了
      provinces.push(provinceId);
      setProvinces(provinces);
      opDescValueProvince.push(provinceId); //这里把有城市被勾选对应的省加入到数组opDescValueProvince中，用来作为opDescValue
      setOpDescValueProvince(opDescValueProvince);
    }else if(citys.length===0){
      //这里表示省下没有任何城市选中
      let index=provinces.indexOf(provinceId);
      if(index>=0){
        provinces.splice(provinces.indexOf(provinceId),1);
      }
      setProvinces(provinces);
    }else{
      //这里表示省下城市部分被选中
      opDescValueProvince.push(provinceId); //这里把有城市被勾选对应的省加入到数组opDescValueProvince中，用来作为opDescValue
      setOpDescValueProvince(opDescValueProvince);
      let index=provinces.indexOf(provinceId);
      if(index>=0){
        provinces.splice(provinces.indexOf(provinceId),1);
      }
    }
    setData();
  };

  const setData = () => {
    let selectedCitys=[];
    provinceToCityMap.forEach((value,key)=>{
      selectedCitys=[...selectedCitys, ...value]
    });
    setCitySelect(selectedCitys);
  }

  // 全选
  const selectAllCity = () => {
    let tempCityId = [];
    for (let value of allCitys) {
      tempCityId.push(value.cityId);
    }
    setCitySelect(tempCityId); // 数据
    onCheckProvince([...allConnectArr.keys()]) //展示
  }
  // 清除全部
  const removeAllCity = () => {
    setCitySelect([]);
    setProvinceSelect([]);
    setProvinces([]);
    setCitySelectConfirm([]);
    provinceToCityMap.forEach((value,key) => {
      setCities(provinceToCityMap.set(key, []));
      setCitiesCopy(provinceToCityMapCopy.set(key, []));
      provincesIndeterminate.set(key,false);
      provincesIndeterminateCopy.set(key,false);
      setProvincesCopy([]);
    })
  }

  // 分组
  const groupBy = (list, fn) => {
    const groups = {};
    list.forEach(function (o) {
      const group = JSON.stringify(fn(o));
      groups[group] = groups[group] || [];
      groups[group].push(o);
    });
    return Object.keys(groups).map(function (group) {
      return groups[group];
    });

  }
  // 生成标签
  const getTagList = () => {
    let tempCitySelect = citySelect;
    // 过滤出当前选中城市
    let tempCity = allCitys;
    let filterCity = [];
    for (let value of tempCitySelect) {
      let tempFilter
      tempFilter = tempCity.filter((item, index) => {
        return Number(item.cityId) === value;
      })
      filterCity.push(tempFilter[0]);
    }
    let groupData = groupBy(filterCity, (item) => {
      return item?.provinceId;
    })
    setTagList(groupData);
  }

  // 标签关闭清除数据
  const tagRemove = (deleteProvinceId) => {
    provinces.forEach((item, index) => {
      if(item === deleteProvinceId){
        provinces.splice(index,1);
      }
    })
    setProvinces(provinces);
    const deleteCitys = [];
    tagList.forEach((item, index) => { //拿到已选择的标签数据，将要被关闭的标签从tagList中移除
      if(item[0].provinceId === deleteProvinceId){
        tagList[index].forEach((deleteItem, deleteIndex) => {
          deleteCitys.push(deleteItem.cityId);
        })
        tagList.splice(index,1);
        setTagList(tagList);
      }
    })
    setCities(provinceToCityMap.set(deleteProvinceId,[]));
    provincesIndeterminate.set(deleteProvinceId,false);
    setCitySelect([...citySelect].filter(x => [...deleteCitys].every(y => y !== x))); //将所选城市从citySelect中移除
    saveList([...citySelect].filter(x => [...deleteCitys].every(y => y !== x))); //将所选城市从citySelect中移除
  }

  // 提交时的数据
  const saveList = (list) => {
    let tempCity = allCitys;
    let filterList = [];
    let tempPr = []
    // 过滤出剩下的city
    for (let value of list) {
      let filterCity = tempCity.filter((item, index) => {
        return item.cityId === value;
      })
      filterList.push(filterCity[0])
    }
    // 将provinceId,cityId 拼成要存入的格式 写入数组中
    let saveArea = [];
    for (let value of filterList) {
      saveArea.push(`${value.provinceId},${value.cityId}`)
      tempPr.push(value.provinceId)
    }
    let arrPr = Array.from(new Set(tempPr))
    props.handlerClick(saveArea)
    // isFirst = true
    setTempSelect({
      pr:arrPr,
      ci:list
    })
  }

  const [tempSelect, setTempSelect] = useState({
    pr:[],
    ci:[]
  })

  //修改或详情的时候，省市反显
  const setCheckedBox = (ids) => {
    let allCheckedProvinceId = [];
    const loopSet = function(){
      let getKey = 0;
      let getValue = [];
      ids.forEach((item, index) => { //处理接口返回的ids数据，分组
        getKey = Number(ids[0].split(',')[0]);
        if(Number(item.split(',')[0]) === getKey){
          getValue.push(Number(item.split(',')[1]));
        }
      })
      setCities(provinceToCityMap.set(getKey,getValue));
      setCitiesCopy(provinceToCityMapCopy.set(getKey,getValue));
      if(allConnectArr.get(getKey)?.length === getValue?.length){ //如果城市数量和该省含有城市总数相等，则去掉中间选择状态并将该省份id放入全选省份id数组中
        provincesIndeterminate.set(getKey,false);
        allCheckedProvinceId.push(getKey);
        setProvinces(allCheckedProvinceId);
        setProvincesCopy(allCheckedProvinceId);
      }else{ //部分选择
        provincesIndeterminate.set(getKey,true);
        provincesIndeterminateCopy.set(getKey,true);
      }
      ids.splice(0,getValue.length);
      getValue = [];
      if(ids.length > 0){
        loopSet();
      }
    }
    loopSet();
  }

  /**
   * 点击确定按钮
   * 将provinceToCityMap 给 provinceToCityMapCopy
   * 将provincesIndeterminate 给 provincesIndeterminateCopy
   * 将provinces 给 provincesCopy
   */
  const productConfirmData = () => {
    provinceToCityMap.forEach((value, key) => {
      setCitiesCopy(provinceToCityMapCopy.set(key, value));
      provincesIndeterminateCopy.set(key,provincesIndeterminate.get(key));
    })
    setProvincesCopy(provinces);
  }

  /**
   * 点击取消按钮
   * 将provinceToCityMapCopy 给 provinceToCityMap
   * 将provincesIndeterminateCopy 给 provincesIndeterminate
   * 将provincesCopy 给 provinces
   */
  const productCancelData = () => {
    provinceToCityMapCopy.forEach((value, key) => {
      setCities(provinceToCityMap.set(key, value));
      provincesIndeterminate.set(key,provincesIndeterminateCopy.get(key));
    })
    setProvinces(provincesCopy);
  }

  useEffect(() => {
    setArea(props.area);
    setAreaType(props.area.type);
    if (props.pageStatus !== 1) {
      if (props.pageStatus === 2) {
        setDisabled(true)
      }
      // ids 不为空
      let tempCitySelect = [];
      let tempProvinceSelect = [];
      if (props.area.ids.length > 0) {
        for (let value of props.area.ids) {
          tempProvinceSelect.push(Number(value.split(',')[0]));
          tempCitySelect.push(Number(value.split(',')[1]));
        }
        let singalProvince = new Set(tempProvinceSelect);
        let singalProvinceList = Array.from(singalProvince);
        setCitySelect(tempCitySelect);
        setProvinceSelect(singalProvinceList);
        setTempSelect({
          pr:singalProvinceList,
          ci:tempCitySelect
        })
        getTagList();
      }

    }
  }, [props]);
  return (
    <div className={styles.paymentarea}>
      <div className={styles.chooseradio}>
        <span className={styles.label}>
          <span className={styles['red-text']}>*</span>
          {type && type === "退款" ? "退款地区：" : type && type === "催评" ? "催评地区：" : type && type === "到货" ? "提醒地区：" :"催付地区："}
        </span>
        <Radio.Group
          direction={'hoz'}
          value={area.type}
          disabled={disabled}
          onChange={(value) => {
            props.chooseAreaType(value);
            setAreaType(value);
            removeAllCity();
            setTagList([]);
          }}
        >
          <Radio value={1}>不限</Radio>
          <Radio value={2}>指定地区<span className={styles['red-text']}>（当收货地区为选定地区时，进行短信{type && type === "催评" ? "催评" : type && type === "到货" ? "关怀" :"催付"}）</span></Radio>
          <Radio value={3}>排除地区<span className={styles['red-text']}>（当收货地区为选定地区时，不进行短信{type && type === "催评" ? "催评" : type && type === "到货" ? "关怀" :"催付"}）</span></Radio>
        </Radio.Group>
      </div>

      {
        areaType != 1 ?
          <div className={styles.pointAreadiv}>
            <div className={styles.pointBtn}>
              <Button
                type="primary"
                className={styles.btn}
                disabled={disabled}
                onClick={() => {
                  setDialog(true);
                  // 当tagList为空，则意味着已选过的省市要么被清除全部，要么地区选择方式已切换(指定地区/排除地区/不限)
                  // tagList为空，省市反显数组不应赋值
                  if(tagList.length !== 0){
                    setCheckedBox(props.area.ids);
                  }else{
                    removeAllCity();
                  }
                }}>
                  选择地区
              </Button>
              {props.pageStatus !== 2 &&
                <Button
                  type='primary'
                  text
                  style={{marginLeft:'20px'}}
                  onClick={() => {
                    setTagList([])
                    removeAllCity()
                    props.clearAll()
                  }}
                >
                  清除全部
                </Button>
              }
            </div>
            <div className={styles.pointTag}>
              <TagGroup>
                { // 页面状态是修改和新建的时侯
                  props.pageStatus !== 2 ? (
                    tagList.map((item, index) => {
                      return (
                        <CloseableTag
                          key={item[0]?.provinceName}
                          onClose={() => {
                            tagRemove(item[0]?.provinceId);
                            return false
                          }}
                          className={styles.tags}
                          onClick={() => {
                            setDialog(true)
                            setCheckedBox(props.area.ids);
                          }}
                        >
                          {item[0]?.provinceName}({item.length})
                        </CloseableTag>
                      )
                    })
                  ) :
                  (
                    // 页面状态时查看的时候
                    tagList.map((item, index) => {
                      return (
                        <Tag key={item[0]?.provinceName}>
                          {item[0]?.provinceName}({item.length})
                        </Tag>
                      )
                    })
                  )
                }
              </TagGroup>
            </div>
          </div> : <div></div>
      }
      {
        dialogShow &&
          <Dialog visible={dialogShow} title="选择地区模板" footer={false} style={{ width: '650px' }}
            onClose={() => {
              setDialog(false);
              setCitySelect(tempSelect.ci);
              setProvinceSelect(tempSelect.pr);
              saveList(tempSelect.ci);
              setCitySelectConfirm(tempSelect.ci);
              setProvinceSelectConfirm(tempSelect.pr);
              productCancelData();
            }}
          >
          <div className={styles['btn-box']}>
            <Button
              type='primary'
              text
              className={styles.mr5}
              disabled={disabled}
              onClick={() => { setProvinceSelect(selectAllProvince); selectAllCity()}}
            >
              全选
            </Button>
            <Button
              type='primary'
              text
              style={{paddingRight: "20px" }}
              disabled={disabled}
              onClick={() => { removeAllCity()}}>
                清除
              </Button>
          </div>
          <div className={styles.province} style={{margin: '0 30px'}}>
            <Checkbox.Group
              direction="hoz"
              key={'province1'}
              onChange={onCheckProvince}
              value={provinces}
            >
              {
                allData.map((province,index) => {
                  return (
                    <Checkbox
                      className={styles.provincechild}
                      indeterminate={provincesIndeterminate.get(province.code)}
                      value={province.code}
                      key={`${province.code}${province.areaName}`}
                    >
                      <Balloon
                        style={{ width: '1520px'}}
                        autoFocus
                        align={"r"}
                        trigger={
                          <span
                            key={`${province.code}${"span"}`}
                            onMouseOver={(v)=>{setDirection(v.target.offsetTop)}}
                          >
                            {province.areaName}
                          </span>}
                        triggerType="hover"
                        closable={false}
                      >
                        <Checkbox.Group
                          direction="hoz"
                          style={{ width: '320px' }}
                          onChange={(value) => { onChangeCity(province.code,value) }}
                          value={provinceToCityMap.get(province.code)}
                          key={`${province.areaName}${province.index}${index}`}
                        >
                          {
                            province.subAreas.map((city,index) => {
                              return (
                                <Checkbox
                                  key={`${city.area_name}${index}`}
                                  value={city.code}
                                  style={{ width: city.area_name.length > 5 ? '100%' : '46%', marginLeft: '2%', marginRight: '2%', marginTop: '5px', color: '#fff' }}
                                  className={styles['order-care-area-city']}>
                                  {city.area_name}
                                </Checkbox>)
                            })
                          }
                        </Checkbox.Group>
                      </Balloon>
                    </Checkbox>
                  )
                })
              }
            </Checkbox.Group>
            </div>
            <hr/>
            <div className={styles['footer-btn-box']}>
              {
                props.pageStatus === 2 ? (
                  <Button
                    type="normal"
                    className={`${styles.btn} ${styles.mr10}`}
                    onClick={() => {
                    setDialog(false);
                    setCitySelect(citySelectConfirm);
                    setProvinceSelect(provinceSelectConfirm);
                    productCancelData()
                  }}
                  >
                    关闭
                  </Button>
                ) :
                (// 新建
                  props.pageStatus === 1 ?
                  (
                    <Button
                      type="normal"
                      className={`${styles.btn} ${styles.mr10}`}
                      disabled={disabled}
                      onClick={() => {
                      setDialog(false);
                      setCitySelect(citySelectConfirm);
                      setProvinceSelect(provinceSelectConfirm);
                      productCancelData();
                    }}>
                      取消
                    </Button>
                ) :
                (
                  // 修改
                  <Button
                    type="normal"
                    className={`${styles.btn} ${styles.mr10}`}
                    disabled={disabled}
                    onClick={() => {
                      setDialog(false);
                      setCitySelect(citySelectConfirm);
                      setProvinceSelect(provinceSelectConfirm);
                      productCancelData();
                    }}
                    >
                      取消
                    </Button>
                  )
                )
              }
              <Button
                type="primary"
                className={styles.btn}
                disabled={disabled}
                onClick={() => {
                  setDialog(false);
                  getTagList();
                  saveList(citySelect);
                  setCitySelectConfirm(citySelect);
                  setProvinceSelectConfirm(provinceSelect);
                  productConfirmData();
                }}>
                  确定
                </Button>
            </div>
        </Dialog>
      }
    </div>
  )
}